<template>
  <div class="testimonial-area pt-100">
    <div class="container mw-1356">
      <div
        class="testimonial-wrap bg-img pb-100"
        :style="{ backgroundImage: `url(${bgImage})` }"
      >
        <div class="section-title text-center mw-860 m-auto mb-90">
          <span class="top-title">آراء العملاء</span>
          <h2 class="text-white">رضا العملاء هو أساس خدمتنا</h2>
          <p class="text-white">
            آراء عملائنا تعكس جودة التجربة واستقرار الخدمة التي نقدمها.
          </p>
        </div>

        <div class="position-relative z-1">
          <Swiper
            :slidesPerView="1"
            :spaceBetween="50"
            :centeredSlides="false"
            :preventClicks="true"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }"
            :navigation="{
              nextEl: '.next',
              prevEl: '.prev',
            }"
            :breakpoints="{
              0: {
                slidesPerView: 1,
              },
              576: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 1,
              },
              992: {
                slidesPerView: 2,
              },
              1440: {
                slidesPerView: 2,
              },
              1600: {
                slidesPerView: 2,
              },
            }"
            :modules="modules"
            class="testomonial-slide-two"
          >
            <SwiperSlide
              v-for="(testimonial, index) in testimonials"
              :key="index"
            >
              <div class="testimonial-single-item-two">
                <div class="d-flex align-items-center mb-32">
                  <div class="flex-shrink-0">
                    <img :src="testimonial.image" :alt="testimonial.name" />
                  </div>
                  <div class="flex-grow-1 ms-4">
                    <ul
                      class="ps-0 list-unstyled d-flex align-items-center gap-1"
                    >
                      <li v-for="star in 5" :key="star">
                        <i class="ti ti-star-filled"></i>
                      </li>
                    </ul>
                    <h3>{{ testimonial.name }}</h3>
                  </div>
                </div>
                <p>{{ testimonial.review }}</p>
              </div>
            </SwiperSlide>
          </Swiper>

          <div class="testomonial-controller">
            <div class="controller-icon prev">
              <i class="ti ti-arrow-left"></i>
            </div>
            <div class="controller-icon next">
              <i class="ti ti-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Navigation } from "swiper/modules";

export default defineComponent({
  name: "OurTestimonial",
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const bgImage = require("@/assets/images/testimonial-bg.png");
    const testimonials = ref([
      {
        image: require("@/assets/images/testimonial-1.jpg"),
        name: "Ahmed Ali",
        review:
          "الخدمة مستقرة جدًا والقنوات تعمل بجودة ممتازة. التجربة كانت سهلة من التفعيل وحتى التشغيل.",
      },
      {
        image: require("@/assets/images/testimonial-2.jpg"),
        name: "Omar Hassan",
        review:
          "دعم سريع وتفعيل بدون تعقيد. أعجبتني جودة البث وتنوع القنوات والأفلام المتاحة.",
      },
      {
        image: require("@/assets/images/testimonial-1.jpg"),
        name: "Khaled Mansour",
        review:
          "جربت أكثر من خدمة قبل ذلك، لكن Loay IPTV كانت أفضل من ناحية الاستقرار وسهولة الاستخدام.",
      },
      {
        image: require("@/assets/images/testimonial-2.jpg"),
        name: "Samer Nabil",
        review:
          "الباقات مناسبة والخدمة ممتازة على التلفاز والهاتف. أنصح بها لمن يريد تجربة مشاهدة مريحة.",
      },
    ]);

    return {
      modules: [Autoplay, Navigation],
      testimonials,
      bgImage,
    };
  },
});
</script>